module.exports = __webpack_public_path__ + "img/DSC_0784.33f8a68e.jpeg";